import { ia } from 'lib/helpers/utility';
import extractDataFromColDefs from 'lib/helpers/pdf/tableExport/lib/extractDataFromColDefs';

import { generateColumnDefs } from 'components/practice/BeyondBilling/Reports/components/ReportView/lib/generateColumnDefs';

// Function to flatten nested children data for CSV/Excel export
// mode: 'summary' = parent rows only, 'detailed' = child rows (optionally with parent context)
export const flattenNestedData = (rows, columns, { mode = 'summary', parentColumns = [] } = {}) => {
  const isDetailed = mode === 'detailed';

  if (!isDetailed) {
    // Summary mode: just format and return parent-level rows (no children)
    return extractDataFromColDefs(rows, columns);
  }

  // Detailed mode: return child rows; prepend parent context when parentColumns is provided
  const hasParentContext = ia(parentColumns);
  let result = [];

  rows.forEach((row) => {
    const children = row.children;

    if (ia(children)) {
      const childCols = ia(columns) ? columns : generateColumnDefs(children);
      const formattedChildren = extractDataFromColDefs(children, childCols);

      if (hasParentContext) {
        const formattedParent = extractDataFromColDefs([row], parentColumns)[0];
        const namespacedParent = Object.fromEntries(
          Object.entries(formattedParent).map(([k, v]) => [`parent_${k}`, v])
        );
        const merged = formattedChildren.map((child) => ({ ...namespacedParent, ...child }));
        result = result.concat(merged);
      } else {
        result = result.concat(formattedChildren);
      }
    }
  });

  return result;
};
